/* tslint:disable */
/* eslint-disable */
export enum PatientBehaviorType {
  Frequency = 1,
  Duration = 2,
  Interval = 3,
  RateTimer = 4,
  Intensity = 5
}
